<template>
    <div class="sk-notification">
        <div class="alert alert-primary alert-dismissible mx-auto my-2 text-left" role="alert">
            <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                v-tooltip="'Delete notification'"
                @click="onCloseClick"
            >
                <span aria-hidden="true">&times;</span>
            </button>
            {{ message.text }}

            <a v-if="message.cta && message.cta.url" class="alert-link" @click.prevent="deleteAndRedirect" :href="message.cta.url"
               :target="message.cta.target">
                {{ message.cta.label }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'notification',
    methods: {
        onCloseClick() {
            this.$emit('delete');
        },
        deleteAndRedirect() {
            this.$emit('deleteAndRedirect');

        }
    },
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.admin-bar .sk-notification {
    top: 106px !important;
}
</style>

<style lang="scss" scoped>
.sk-notification {
    position: fixed;
    top: 100px;
    z-index: 999;
}

.alert-primary {
    background-color: #beeeee;
    border-color: #89e1e1;
    color: #119f9e;

    & > button.close {
        color: #119f9e;
        font-size: 32px;
        opacity: 1;

        &:hover {
            color: #000000;
            background-color: unset;
            border-color: unset;
            opacity: 0.5;
        }
    }

    & > .alert-link {
        color: #119f9e;

        &:hover {
            text-decoration: underline !important;
        }
    }
}
</style>
